import { Pipe, PipeTransform, inject } from '@angular/core';
import { GeneralUserService } from '@coin/shared/auth/data-access';
import { Observable, of } from 'rxjs';
import { Employee } from '@coin/shared/core/util-models';

@Pipe({
  name: 'employeeGid$',
  standalone: true
})
export class EmployeeGidPipe implements PipeTransform {
  private readonly employeeService = inject(GeneralUserService);

  transform(gid: string): Observable<Employee> {
    if (gid) {
      return this.employeeService.getEmployeeDetailsByGid(gid);
    }
    return of(null);
  }
}
